import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import PageTitleContainer from "../containers/global/page-title";
import ProjectDetailsContainer from "../containers/project-details";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import ProjectData from "../data/project.json";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";

import { useParams } from "react-router-dom";
import axios from "axios";

const ProjectDetails = () => {
    const { id } = useParams();
    console.log(id);

    const [project, setProject] = useState();

    // const projectId = parseInt(id, 10);
    // const data = ProjectData.filter((project) => project.id === projectId);
    // const title = data[0].title;
    // const cate = data[0].categories.map((value, idx) => {
    //     return (
    //         <span className="d-inline" key={idx}>
    //             {value}
    //             {idx !== data[0].categories.length - 1 && " , "}
    //         </span>
    //     );
    // });

    // console.log(cate);

    useEffect(() => {
        axios
            .get("https://soul-house-harmony.onrender.com/project/" + id)
            .then((res) => {
                console.log(res.data);
                setProject(res.data);
                // const temp = [];
                // res.data.allProjects.map((x) => {
                //     temp.push({
                //         id: x._id,
                //         media: { thumb: x.cover },
                //         title: x.name,
                //     });
                // });
                // setData(temp);
            })
            .catch((err) => {
                console.log(err);
                cogoToast.info("Error submitting form", {
                    position: "bottom-left",
                });
            });
    }, []);

    return (
        <React.Fragment>
            <Layout>
                <SEO title="Andle - Project Details" />
                <div className="main-wrapper">
                    <Header />

                    <PageTitleContainer
                        title={project?.project.name}
                        subTitle={project?.project.description}
                    />
                    <ProjectDetailsContainer data={project ? project : null} />
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

ProjectDetails.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
    }),
};

export default ProjectDetails;
